import { TKey } from "@/app/translations/TKey";
import { LaunchCountdownParts, LaunchCountdownUnit } from "@/app/types/home/LaunchCountdown";
import { UDate } from "@/app/utils/UDate";
import { Globals } from "@/app/vars/Globals";

export const LAUNCH_COUNTDOWN_TICK_MS = 1000;

export const EMPTY_LAUNCH_COUNTDOWN_PARTS: LaunchCountdownParts = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
};

const LAUNCH_TIME_ZONE = "Europe/Paris";
const HOUR_MS = 60 * 60 * 1000;
const MINUTE_MS = 60 * 1000;
const SECOND_MS = 1000;

export function getLaunchCountdownParts(now: number): LaunchCountdownParts | null {
  const remaining = new Date(Globals.LAUNCH_DATE).getTime() - now;
  if (remaining <= 0) {
    return null;
  }
  return {
    days: Math.floor(remaining / UDate.DAY_MS),
    hours: Math.floor((remaining % UDate.DAY_MS) / HOUR_MS),
    minutes: Math.floor((remaining % HOUR_MS) / MINUTE_MS),
    seconds: Math.floor((remaining % MINUTE_MS) / SECOND_MS),
  };
}

export function getLaunchCountdownUnits(parts: LaunchCountdownParts): LaunchCountdownUnit[] {
  return [
    { value: parts.days, labelKey: TKey.HOME_LAUNCH_COUNTDOWN_DAYS },
    { value: parts.hours, labelKey: TKey.HOME_LAUNCH_COUNTDOWN_HOURS },
    { value: parts.minutes, labelKey: TKey.HOME_LAUNCH_COUNTDOWN_MINUTES },
    { value: parts.seconds, labelKey: TKey.HOME_LAUNCH_COUNTDOWN_SECONDS },
  ];
}

export function formatLaunchDate(lang: string): string {
  return new Intl.DateTimeFormat(lang, {
    day: "numeric",
    month: "long",
    timeZone: LAUNCH_TIME_ZONE,
  }).format(new Date(Globals.LAUNCH_DATE));
}
